/* ════ WHAT'S NEW (once per version) ═══════════════════════ */
import { $ } from './dom.js';
import { APP_VERSION, WHATS_NEW } from './config.js';
import { changelogHtml } from './changelog.js';

const KEY = 'grantt_seen_version';

// Full changelog, opened from the toolbar ✨ button.
function openChangelog() {
  $('wn-title').textContent = 'What’s new';
  $('wn-body').innerHTML = changelogHtml();
  $('whatsnew-modal').classList.add('open');
}

// Show the popup once per version (works whether the user just logged in or
// refreshed an existing session). Dismissal is remembered in localStorage.
export function maybeWhatsNew() {
  try { if (localStorage.getItem(KEY) === APP_VERSION) return; } catch (e) { /* private mode */ }
  $('wn-title').textContent = `What’s new in ${APP_VERSION}`;
  $('wn-body').innerHTML = WHATS_NEW;
  setTimeout(() => $('whatsnew-modal').classList.add('open'), 400);
}

function dismiss() {
  try { localStorage.setItem(KEY, APP_VERSION); } catch (e) { /* ignore */ }
  $('whatsnew-modal').classList.remove('open');
}

export function initWhatsNew() {
  $('wn-ok').addEventListener('click', dismiss);
  $('wn-x').addEventListener('click', dismiss);
  $('btn-news').addEventListener('click', openChangelog);
}
